import Button from "../Button";

export default function ConfirmationModal({
  children,
  onCancel,
  onConfirm,
  isPending = false,
}: {
  children?: React.ReactNode;
  onCancel: () => void;
  onConfirm: () => void;
  isPending?: boolean;
}) {
  return (
    <div className="flex flex-col gap-4 p-8">
      <div className="text-lg font-semibold">{children}</div>
      <div className="flex justify-between items-center">
        <Button onClick={onCancel}>Cancel</Button>
        <Button primary loading={isPending} onClick={onConfirm}>
          OK
        </Button>
      </div>
    </div>
  );
}
